import React from 'react';

const OffersGeo = ({ prices, isCollapsed, collapsedItems, id }) =>
  prices.length > 0 && (
    <div className="offers-list-table-cell">
      <ul className="offer-geo-list offer-values-list list-unstyled no-margin">
        {prices.map((price, index) => {
          if (!isCollapsed || index < collapsedItems) {
            return (
              <li className="offer-prices-list-item" key={`offer_prices_${id}_${price.code}`}>
                <span className={`flag-icon flag-icon-${price.code.toLowerCase()}`}></span>
                {price.country}
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );

export default OffersGeo;
